module.exports = __webpack_public_path__ + "img/070-tuvalu-1.ba380bd7.svg";